import { render, staticRenderFns } from "./PageZhengce.vue?vue&type=template&id=e1e6102c&"
import script from "./PageZhengce.vue?vue&type=script&lang=js&"
export * from "./PageZhengce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports